import { ThunkAction } from 'redux-thunk'
import { StoreState } from 'store'
import { AlertsUserAction, AlertsUserActionTypes } from './alertsUserTypes'
import apiRest from '../../services/apiRest'
import errorHandler from '../../errorHandler'

export function getAlertsUser(): ThunkAction<
  Promise<void>,
  StoreState,
  undefined,
  AlertsUserAction
> {
  return async (dispatch, getState) => {
    try {
      const { selectedChurchIndex, user } = getState().sessionState
      const churchId = user?.churches?.[selectedChurchIndex]?.id
      dispatch({
        type: AlertsUserActionTypes.GET_ALERTS_USER_START,
      })

      const { data: alertsUser } = await apiRest({
        method: 'GET',
        url: 'user-alerts',
        params: {
          churchId,
        },
      })

      dispatch({
        type: AlertsUserActionTypes.GET_ALERTS_USER_SUCCESS,
        alertsUser,
      })
    } catch (error) {
      errorHandler(error)
      dispatch({
        type: AlertsUserActionTypes.GET_ALERTS_USER_ERROR,
      })
    }
  }
}

export function putAlertsUser(
  id: string,
  form: any
): ThunkAction<Promise<void>, StoreState, undefined, AlertsUserAction> {
  return async (dispatch, getState) => {
    try {
      await apiRest({
        method: 'PUT',
        url: 'user-alerts',
        params: { id },
        data: form,
      })
    } catch (error) {
      errorHandler(error)
      dispatch({
        type: AlertsUserActionTypes.PUT_ALERTS_USER_ERROR,
      })
    }
  }
}
